import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME } from "./attributes";

import { SharedCryptoSelect } from "@/components/shared";
import { SharedCryptoSelectOption } from "@/shared/constants/constants";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    SharedCryptoSelect,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: <PropType<SharedCryptoSelectOption[]>>Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  emits: {
    "update:value": null,
    create: null,
  },
});
